import React, { useState, useEffect, useRef } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { i18n } from "../../translate/i18n";
import TextField from "@material-ui/core/TextField";
import api from "../../services/api";
import { Autocomplete } from "@mui/material";
import Chip from "@mui/material/Chip";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";

const FlowBuilderAddSwitchFlowModal = ({
  open,
  onSave,
  onUpdate,
  data,
  close,
}) => {
  const isMounted = useRef(true);

  const initialState = {
    message: "",
    answerKey: "",
  };

  const [message, setMessage] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [integration, setIntegration] = useState();
  const [flowsData, setFlowsData] = useState();
  const [flowsDataObject, setFlowsDataObj] = useState();
  const [flowSelected, setFlowSelected] = useState();

  const [labels, setLabels] = useState({
    title: "Adicionar Perguta ao fluxo",
    btn: "Adicionar",
  });

  useEffect(() => {
    getFlows();
    if (open === "edit") {
      setLabels({
        title: "Editar Perguta do fluxo",
        btn: "Salvar",
      });
      const existing = data?.data?.flowSelected;
      const selectedName =
        typeof existing === "string"
          ? existing
          : existing && typeof existing === "object"
          ? existing.name || ""
          : "";
      setFlowSelected(selectedName);
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: "Cria Perguta no fluxo",
        btn: "Salvar",
      });

      setFlowSelected("");
      setActiveModal(true);
    }

    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const getFlows = async () => {
    return await api.get("/flowbuilder").then((res) => {
      setFlowsData(res.data.flows.map((flow) => flow.name));
      setFlowsDataObj(res.data.flows);
      return res.data.flows;
    });
  };

  const handleSaveContact = (values) => {
    if (open === "edit") {
      handleClose();
      const selected = flowsDataObject?.find((flow) => flow.name === flowSelected);
      const flowSelectedObj = selected
        ? { id: selected.id, name: selected.name }
        : { name: flowSelected || "" };
      onUpdate({
        ...data,
        data: { ...data.data, flowSelected: flowSelectedObj },
      });
    } else if (open === "create") {
      const selected = flowsDataObject?.find((flow) => flow.name === flowSelected);
      const flowSelectedObj = selected
        ? { id: selected.id, name: selected.name }
        : { name: flowSelected || "" };
      handleClose();
      onSave({
        flowSelected: flowSelectedObj,
      });
    }
  };

  const hasFlows = Boolean(flowsDataObject && flowsDataObject.length);

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={
          open === "create"
            ? `Adicionar Troca de Fluxo`
            : `Editar Troca de Fluxo`
        }
        subtitle="Leva a conversa para outro fluxo a partir deste ponto."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField
          label="Fluxo de destino"
          htmlFor="flow-switch-select"
          help={hasFlows ? undefined : "Nenhum fluxo disponível para escolher."}
        >
          {hasFlows && (
            <Autocomplete
              id="flow-switch-select"
              size="small"
              value={flowSelected || ""}
              options={flowsData || []}
              onChange={(event, newValue) => {
                setFlowSelected(newValue);
              }}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Escolha um fluxo"
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option}
                    {...getTagProps({ index })}
                  />
                ))
              }
            />
          )}
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleSaveContact}
        >
          {open === "create" ? `Adicionar` : "Editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddSwitchFlowModal;
